// detectDevice — coarse device family the customer is ordering / uploading from.
// Used to capture (once, first-non-null-wins) which device a customer used so
// the admin can see it as a badge on the order. Mirrors the iPad-disambiguation
// trick from @/lib/isIOS (iPadOS 13+ reports a desktop "Macintosh" UA, so we
// fall back to maxTouchPoints to tell a real Mac from an iPad).
export function detectDevice(): 'iPhone' | 'iPad' | 'Android' | 'Mobile' | 'Desktop' {
  if (typeof navigator === 'undefined') return 'Desktop';
  const ua = navigator.userAgent || '';
  const touch = navigator.maxTouchPoints ?? 0;
  if (/iPhone|iPod/.test(ua)) return 'iPhone';
  if (/iPad/.test(ua) || (/Macintosh/.test(ua) && touch > 1)) return 'iPad';
  if (/Android/.test(ua)) return 'Android';
  if (/Mobile/.test(ua)) return 'Mobile';
  return 'Desktop';
}
